import React from 'react';
import App from './App';
import ReactDOM from 'react-dom';
import getFirebaseConfig from './firebase/config';
import { initializeCustomData } from './utils/customData';
import { initializeApp } from '@firebase/app';
import {
  CartProvider,
  ThemeProvider,
  GlobalProvider,
  APICacheProvider,
  CookieConsentProvider,
  SuccessDrawerProvider,
} from './context';
import 'focus-visible';
import 'assets/main.css';
import './i18n';

if (!window.dataLayer) window.dataLayer = [];
window.dataLayer.push({
  event: 'default_consent',
  consent: {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  },
});

const firebaseConfig = getFirebaseConfig();

initializeApp(firebaseConfig);
initializeCustomData();

ReactDOM.render(
  (
    <React.StrictMode>
      <APICacheProvider>
        <ThemeProvider>
          <CookieConsentProvider>
            <GlobalProvider>
              <CartProvider>
                <SuccessDrawerProvider>
                  <App />
                </SuccessDrawerProvider>
              </CartProvider>
            </GlobalProvider>
          </CookieConsentProvider>
        </ThemeProvider>
      </APICacheProvider>
    </React.StrictMode>
  ) as any,
  document.getElementById('root')
);
